interface REPORT_PROPS {
    name: string
    link: string
    state: boolean
}
function getPermission(permissionName: string): boolean {
    if (typeof window !== 'object') return false
    if (typeof window['Live'] !== 'object') return false
    if (typeof window['Live']['authorization'] !== 'object') return false
    if (typeof window['Live']['authorization']['permissions'] !== 'object') return false
        
    return window['Live']['authorization']['permissions'][permissionName] !== undefined
}

export  const GENERAL_INFORMATION = getPermission('GENERAL_INFORMATION')
export const RECIPIENT_GROUPS = getPermission('RECIPIENT_GROUPS')
export const SCHEDULING = getPermission('SCHEDULING')
export const REPORT_CONTENT = getPermission('REPORT_CONTENT')
export  const CREATE_NEW_REPORT = getPermission('CREATE_NEW_REPORT')

export  const GENERAL_INFORMATION_LINK = 'generalinformation'
export const RECIPIENT_GROUPS_LINK = 'recipientgroups'
export const SCHEDULING_LINK = 'scheduling'
export const REPORT_CONTENT_LINK = 'content'
export const REPORT_PREVIEW_LINK = 'preview'

const REPORT_LINKS = [
    { name: 'General Information', link: GENERAL_INFORMATION_LINK, state: GENERAL_INFORMATION },
    { name: 'Recipient Groups', link: RECIPIENT_GROUPS_LINK, state: RECIPIENT_GROUPS },
    { name: 'Scheduling', link: SCHEDULING_LINK, state: SCHEDULING },
    { name: 'Report Content', link: REPORT_CONTENT_LINK, state: REPORT_CONTENT },
    { name: 'Preview and Test', link: REPORT_PREVIEW_LINK, state: true }
]

export function filterAllowedReportLink(): REPORT_PROPS[] {
    return REPORT_LINKS.filter(report => report.state)
}
